import {NgModule, ErrorHandler} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {FormsModule} from "@angular/forms";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import { StoreModule } from '@ngrx/store';
import {ActivateComponent} from './pages/activate/activate.component';
import {PhoneMaskDirective} from './directives/phone-mask.directive';
import {AccountComponent} from './pages/account/account.component';
import {LoaderComponent} from './loader/loader.component';
import {HttpInterceptorService} from "./services/http-interceptor.service";
import {HeaderComponent} from './header/header.component';
import {SurveyComponent} from "./pages/survey/survey.component";
import {PollsComponent} from './pages/polls/polls.component';
import {FavoritesComponent} from './pages/favorites/favorites.component';
import {OrdersHistoryNewComponent} from './pages/orders-history-new/orders-history-new.component';
import {OrdersComponent} from './pages/orders/orders.component';
import {PersonalComponent} from './pages/personal/personal.component';
import {ContenteditableDirective} from './directives/contenteditable.directive';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {NgSelectModule} from '@ng-select/ng-select';
import {DeletedComponent} from './pages/deleted/deleted.component';
import {BasketComponent} from './pages/basket/basket.component';
import {NgxPaginationModule} from "ngx-pagination";
import {SiteBlockedComponent} from './pages/site-blocked/site-blocked.component';
import {BasketConfirmComponent} from "./pages/basket-confirm/basket-confirm.component";
import {ModalWholesalersComponent} from './header/modal-wholesalers/modal-wholesalers.component';
import {ModalSupplierComponent} from './header/modal-supplier/modal-supplier.component';
import {ModalAboutUsComponent} from './header/modal-about-us/modal-about-us.component';
import {
  ModalConditionsInformationComponent
} from './header/modal-conditions-information/modal-conditions-information.component';
import {ModalOfertaComponent} from './header/modal-oferta/modal-oferta.component';
import {ModalOfertaCookieComponent} from './header/modal-oferta-cookie/modal-oferta-cookie.component';
import {ModalMeinPositionComponent} from './header/modal-mein-position/modal-mein-position.component';
import {ModalCurrenciesComponent} from './header/modal-currencies/modal-currencies.component';
import {ModalContactsComponent} from './header/modal-contacts/modal-contacts.component';
import {ModalReturnsComponent} from './header/modal-returns/modal-returns.component';
import {ModalReturnsInformationComponent} from './header/modal-returns-information/modal-returns-information.component';
import {
  ModalExpectedReceiptGoodsComponent
} from './header/modal-expected-receipt-goods/modal-expected-receipt-goods.component';
import {ModalReceiptsComponent} from './header/modal-receipts/modal-receipts.component';
import {ModalCardsComponent} from './header/modal-cards/modal-cards.component';
import {ModalPaymentComponent} from './header/modal-payment/modal-payment.component';
import {ModalPaymentSuccessComponent} from './header/modal-payment-success/modal-payment-success.component';
import {ModalHistoryComponent} from './header/modal-history/modal-history.component';
import {ModalOrdersHistoryNewComponent} from './header/modal-orders-history-new/modal-orders-history-new.component';
import {ModalMessageComponent} from './header/modal-message/modal-message.component';
import {ModalDeliveryComponent} from './header/modal-delivery/modal-delivery.component';
import {ModalOrderReturnComponent} from './pages/orders-history-new/modal-order-return/modal-order-return.component';
import {
  ModalNpDiscountInfoComponent
} from './pages/basket-confirm/modals/modal-np-discount-info/modal-np-discount-info.component';
import {ModalNalojkaInfoComponent} from './pages/basket-confirm/modals/modal-nalojka-info/modal-nalojka-info.component';
import {ModalTrackStatusComponent} from './pages/orders-history-new/modal-track-status/modal-track-status.component';
import {
  ModalSelectGoodsReturnComponent
} from './pages/orders/modal-select-goods-return/modal-select-goods-return.component';
import {
  ModalFormationRequestReturnComponent
} from './pages/orders/modal-formation-request-return/modal-formation-request-return.component';
import {
  ModalNpDropshipInfoComponent
} from './pages/basket-confirm/modals/modal-np-dropship-info/modal-np-dropship-info.component';
import {
  MessageDeliveryConfirmComponent
} from './pages/basket-confirm/messages/message-delivery-confirm/message-delivery-confirm.component';
import {
  MessageDeliveryBrojkoConfirmComponent
} from './pages/basket-confirm/messages/message-delivery-brojko-confirm/message-delivery-brojko-confirm.component';
import {
  MessageDeliveryNPConfirmComponent
} from './pages/basket-confirm/messages/message-delivery-np-confirm/message-delivery-np-confirm.component';
import {
  MessageDeliveryDLConfirmComponent
} from './pages/basket-confirm/messages/message-delivery-dl-confirm/message-delivery-dl-confirm.component';
import {
  MessageDeliveryDropshippingConfirmComponent
} from './pages/basket-confirm/messages/message-delivery-dropshipping-confirm/message-delivery-dropshipping-confirm.component';
import {ModalInfoPaymentComponent} from './pages/basket-confirm/modals/modal-info-payment/modal-info-payment.component';
import {
  ModalCashOnDeliveryInfoComponent
} from './pages/basket-confirm/modals/modal-cash-on-delivery-info/modal-cash-on-delivery-info.component';
import {
  ModalTtnStatusShowComponent
} from './pages/orders-history-new/modal-ttn-status-show/modal-ttn-status-show.component';
import {MenuComponent} from './pages/menu/menu.component';
import {FlagComponent} from './flag/flag.component';
import {NovaPoshtaComponent} from './pages/basket-confirm/deliveries/nova-poshta/nova-poshta.component';
import {MeestExpressComponent} from './pages/basket-confirm/deliveries/meest-express/meest-express.component';
import {PickupAmosovaComponent} from './pages/basket-confirm/deliveries/pickup-amosova/pickup-amosova.component';
import {PickupBrojkaComponent} from './pages/basket-confirm/deliveries/pickup-brojka/pickup-brojka.component';
import {DeliveryComponent} from './pages/basket-confirm/deliveries/delivery/delivery.component';
import {DropshipComponent} from './pages/basket-confirm/deliveries/dropship/dropship.component';
import {
  DeliveryTargetedComponent
} from './pages/basket-confirm/deliveries/delivery-targeted/delivery-targeted.component';
import {DeliveryListComponent} from './pages/basket-confirm/delivery-list/delivery-list.component';
import {GoodComponent} from './pages/good/good.component';
import {ModalGoodInformationComponent} from './pages/good/modal-good-information/modal-good-information.component';
import {ModalImgComponent} from './pages/good/modal-good-information/modal-img/modal-img.component';
import {GalleriaModule} from "primeng/galleria";
import {CarouselModule} from "primeng/carousel";
import {TagModule} from "primeng/tag";
import { GoodsListComponent } from './shared/goods-list/goods-list.component';
import { PartnerWhHintComponent } from './shared/partner-warehouses/partner-wh-hint.component';
import { PartnerWhRowComponent } from './shared/partner-warehouses/partner-wh-row.component';
import { NavigationMenuComponent } from './shared/navigation-menu/navigation-menu.component';
import { CategoriesMenuComponent } from './shared/categories-menu/categories-menu.component';
import { ModalGoodAddToBasketMobileComponent } from './pages/good/modal-good-add-to-basket-mobile/modal-good-add-to-basket-mobile.component';
import { ModalChangeDeliveryDateComponent } from './pages/orders-history-new/modal-change-delivery-date/modal-change-delivery-date.component';
import {ErrorHandlerService} from "./services/error-handler.service";
import {haveGoodsReducer} from "./store/have-goods/have-goods.reducer";
import { ModalNonReturnableItemsComponent } from './pages/account/modal-non-returnable-items/modal-non-returnable-items.component';
import { ModalPartnersNotReturnOrdersMessageComponent } from './pages/orders/modal-partners-not-return-orders-message/modal-partners-not-return-orders-message.component';
import { ModalApiInstructionComponent } from './header/modal-api-instruction/modal-api-instruction.component';
import {includePartnersReducer} from "./store/include-partners/include-partners.reducer";
import { ModalNoSelectedGoodsComponent } from './pages/basket/modal-no-selected-goods/modal-no-selected-goods.component';
import { ModalUploadOrderComponent } from './pages/basket/modal-upload-order/modal-upload-order.component';
import { ModalOrganizationComponent } from './pages/personal/modal-organization/modal-organization.component';
import { ModalBuCalculationsComponent } from './shared/categories-menu/modal-bu-calculations/modal-bu-calculations.component';
import { ModalNpCompactPackInfoComponent } from './pages/basket-confirm/modals/modal-np-compact-pack-info/modal-np-compact-pack-info.component';
import { DeliveryEstimateComponent } from './shared/delivery-estimate/delivery-estimate.component';
import { OrderInProgressMessageComponent } from './shared/order-in-progress-message/order-in-progress-message.component';
import { HttpErrorMessageComponent } from './shared/http-error-message/http-error-message.component';
import { AssistantWidgetComponent } from './shared/assistant-widget/assistant-widget.component';

@NgModule({
  declarations: [
    AppComponent,
    ActivateComponent,
    PhoneMaskDirective,
    AccountComponent,
    LoaderComponent,
    HeaderComponent,
    SurveyComponent,
    PollsComponent,
    FavoritesComponent,
    OrdersHistoryNewComponent,
    OrdersComponent,
    PersonalComponent,
    ContenteditableDirective,
    DeletedComponent,
    BasketComponent,
    SiteBlockedComponent,
    BasketConfirmComponent,
    ModalWholesalersComponent,
    ModalSupplierComponent,
    ModalAboutUsComponent,
    ModalConditionsInformationComponent,
    ModalOfertaComponent,
    ModalOfertaCookieComponent,
    ModalMeinPositionComponent,
    ModalCurrenciesComponent,
    ModalContactsComponent,
    ModalReturnsComponent,
    ModalReturnsInformationComponent,
    ModalExpectedReceiptGoodsComponent,
    ModalReceiptsComponent,
    ModalCardsComponent,
    ModalPaymentComponent,
    ModalPaymentSuccessComponent,
    ModalHistoryComponent,
    ModalOrdersHistoryNewComponent,
    ModalMessageComponent,
    ModalDeliveryComponent,
    ModalOrderReturnComponent,
    ModalNpDiscountInfoComponent,
    ModalNalojkaInfoComponent,
    ModalNpDropshipInfoComponent,
    ModalTrackStatusComponent,
    ModalSelectGoodsReturnComponent,
    ModalFormationRequestReturnComponent,
    MessageDeliveryConfirmComponent,
    MessageDeliveryBrojkoConfirmComponent,
    MessageDeliveryNPConfirmComponent,
    MessageDeliveryDLConfirmComponent,
    MessageDeliveryDropshippingConfirmComponent,
    ModalInfoPaymentComponent,
    ModalCashOnDeliveryInfoComponent,
    ModalTtnStatusShowComponent,
    MenuComponent,
    FlagComponent,
    NovaPoshtaComponent,
    MeestExpressComponent,
    PickupAmosovaComponent,
    PickupBrojkaComponent,
    DeliveryComponent,
    DropshipComponent,
    DeliveryTargetedComponent,
    DeliveryListComponent,
    GoodComponent,
    ModalGoodInformationComponent,
    ModalImgComponent,
    GoodsListComponent,
    PartnerWhHintComponent,
    PartnerWhRowComponent,
    NavigationMenuComponent,
    CategoriesMenuComponent,
    ModalGoodAddToBasketMobileComponent,
    ModalChangeDeliveryDateComponent,
    ModalNonReturnableItemsComponent,
    ModalPartnersNotReturnOrdersMessageComponent,
    ModalApiInstructionComponent,
    ModalNoSelectedGoodsComponent,
    ModalUploadOrderComponent,
    ModalOrganizationComponent,
    ModalBuCalculationsComponent,
    ModalNpCompactPackInfoComponent,
    DeliveryEstimateComponent,
    OrderInProgressMessageComponent,
    HttpErrorMessageComponent,
    AssistantWidgetComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ClipboardModule,
    NgSelectModule,
    NgxPaginationModule,
    GalleriaModule,
    BrowserAnimationsModule,
    CarouselModule,
    TagModule,
    StoreModule.forRoot({
      haveGoodsStore: haveGoodsReducer,
      includePartnersStore: includePartnersReducer,
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    {
      provide: ErrorHandler, useClass: ErrorHandlerService
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
